export function DisableRuleIcon() {
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.9573 1C3.27351 1 1 6.1154 1 6.1154C1 6.1154 3.27351 11.2308 8.9573 11.2308C14.6411 11.2308 16.9146 6.1154 16.9146 6.1154C16.9146 6.1154 14.6411 1 8.9573 1Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M8.95517 8.95331C10.5247 8.95331 11.7971 7.68096 11.7971 6.11142C11.7971 4.54189 10.5247 3.26953 8.95517 3.26953C7.38564 3.26953 6.11328 4.54189 6.11328 6.11142C6.11328 7.68096 7.38564 8.95331 8.95517 8.95331Z"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
